/**
 * Synchronizes About page text-and-image card heights.
 */
document.addEventListener('DOMContentLoaded', function() {
  function updateAboutCardHeights() {
    if (window.innerWidth > 1024) {
      const aboutCards = document.querySelectorAll('.about-card');
      aboutCards.forEach(function(card) {
        const textContainer = card.querySelector('.about-card-text');
        const imageContainer = card.querySelector('.about-card-image');
        if (textContainer && imageContainer) {
          const height = textContainer.offsetHeight;
          imageContainer.style.height = height + 'px';
        }
      });
    } else {
      const aboutCards = document.querySelectorAll('.about-card');
      aboutCards.forEach(function(card) {
        const imageContainer = card.querySelector('.about-card-image');
        if (imageContainer) {
          imageContainer.style.height = '';
        }
      });
    }
  }
  
  updateAboutCardHeights();
  window.addEventListener('resize', updateAboutCardHeights);
});